import membersForms from 'src/services/api/membersForms';

export const mapGuestToAttendant = (guest = {}) => ({
  id: guest.id,
  name: guest.name || '',
  lastName: guest.lastName || '',
  identification: guest.identification != null ? String(guest.identification) : '',
  phone: guest.phone != null ? String(guest.phone) : '',
  email: guest.email || '',
  gender: guest.gender || '',
  civil: guest.civil || '',
  birthdate: guest.birthdate || '',
  ocupation: guest.ocupation || '',
  photo: guest.photo || '',
});

export const baseAttendantFromInputs = ({ identification, phone } = {}) => ({
  identification: identification != null ? String(identification) : '',
  phone: phone != null ? String(phone) : '',
});

const attachGroupMembership = (attendant, data = {}) => ({
  ...attendant,
  alreadyInGroup: Boolean(data.alreadyInGroup),
  groupMember: data.groupMember || null,
  Attendants: data.Attendants || null,
});

export const attendantFromNewMembersLookup = (data = {}, { identification, phone } = {}) => {
  const creds = baseAttendantFromInputs({ identification, phone });

  if (data.alreadySubmitted && data.guest) {
    return attachGroupMembership(
      {
        ...creds,
        ...mapGuestToAttendant(data.guest),
        alreadySubmitted: true,
        submittedAt: data.submittedAt,
        interestedGroup: 'Sí',
      },
      data
    );
  }

  if (data.finded && data.match && data.guest) {
    return attachGroupMembership(
      {
        ...creds,
        ...mapGuestToAttendant(data.guest),
      },
      data
    );
  }

  return null;
};

export const fetchNewMembersLookup = ({ identification, phone, captcha, captchaRequired }) =>
  membersForms.newMembersLookup({
    identification,
    phone,
    ...(captchaRequired ? { captcha } : {}),
  });
